export default __webpack_public_path__ + "static/media/map-placeholder2.c60b923c.jpg";